import fetch from 'auth/FetchInterceptor'
import { auth_signin, auth_signinv2, get_user } from 'utils/api_urls'
import Request from 'utils/request'

const AuthService = {}

AuthService.login = function (data) {
	return Request.postRequest(auth_signin, data)
}

AuthService.loginv2 = function (data) {
	return Request.postRequest(auth_signinv2, data)
}

AuthService.getByToken = function () {
	return Request.getRequest(get_user)
}

AuthService.register = function (data) {
	return fetch({
		url: '/auth/register',
		method: 'post',
		data: data
	})
}

AuthService.getList = function (pageNumber=1, pageSize=10, search='', status='') {
	return Request.getRequest(`auth/list?pageNumber=${pageNumber}&pageSize=${pageSize}&query=${search}&status=${status}`)
}

AuthService.create = function (data) {
	return Request.postRequest(`auth/signup`, data)
}

AuthService.updateUser = function (data) {
	return Request.putRequest(`auth/update`, data)
}

AuthService.statusChange = function (id, status) {
	return Request.putRequest(`auth/changeStatus?adminId=${id}&status=${status}`)
}

AuthService.checkUsername = function (username) {
	return Request.getRequest(`auth/checkUsername?username=${username}`)
}
AuthService.checkUsernameUpdate = function (username,id) {
	return Request.getRequest(`auth/checkUsernameUpdate?username=${username}&&id=${id}`)
}
AuthService.update = function (id, data) {
	return Request.putRequest(`auth/update?adminId=${id}`, data)
}

AuthService.getById = function (id) {
    return Request.getRequest(`auth/getById?id=${id}`)
}

AuthService.deleteById = function (id) {
    return Request.deleteRequest(`auth/deleteById?id=${id}`)
}

AuthService.getAdminSessions = function (id, pageNumber=1, pageSize=10) {
    return Request.getRequest(`auth/getAdminSessions/${id}?pageNumber=${pageNumber}&pageSize=${pageSize}`)
}

AuthService.getAdminServices = function (id, pageNumber=1, pageSize=10) {
    return Request.getRequest(`auth/getAdminServices/${id}?pageNumber=${pageNumber}&pageSize=${pageSize}`)
}


export default AuthService;